import React, { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import TransactionTable from "../../Transactions/Table";
import DuesTable from "../../Dues/Table";
import SecurityTable from "./SecurityTable";
import NotFoundModel from "../../NotFoundModel";
import Loading from "../../Loading";
import { compressAmount } from "../../../helpers";
import { useSelector } from "react-redux";

const Passbook = ({
  data,
  error,
  isLoading,
  setSelectedData,
  selectedData,
  isRefetching,
  goTo,
  isMarkAsPaidVisible,
  setIsMarkAsPaidVisible
}) => {
  const user = useSelector((state) => state.UserReducer.user);

  const [selectedBox, setSelectedBox] = useState("totalTransaction");
  const [selectedTable, setSelectedTable] = useState("totalTransaction");

  useEffect(() => {
    setSelectedTable(goTo);
    setSelectedBox(goTo);
  }, [goTo]);

  const handleBoxClick = (type) => {
    setSelectedTable(type);
    setSelectedBox(type);
  };

  return (
    <>
      <BookingSummary>
        <BookingGrid>
          <BoxComp
            value={data.totalTransaction}
            title="Total Collection"
            className={`bg-teal-50 text-teal-400 border-b-teal-400`}
            selected={`${selectedBox === "totalTransaction"
                ? "border-l-4 border-l-teal-400"
                : ""
              }`}
            onClick={() => handleBoxClick("totalTransaction")}
          />
          <BoxComp
            value={data.totalDues}
            title={`Total Due`}
            className="bg-rose-50 text-rose-400 border-b-rose-400"
            selected={`${selectedBox === "totalDues" ? "border-l-4 border-l-rose-400" : ""
              }`}
            onClick={() => handleBoxClick("totalDues")}
          />
          <BoxComp
            value={data.totalSecurityDeposit}
            title={`Security Deposit`}
            className="bg-blue-50 text-blue-400 border-b-blue-400"
            selected={`${selectedBox === "security" ? "border-l-4 border-l-blue-400" : ""
              }`}
            onClick={() => handleBoxClick("security")}
          />
          <BoxComp
            value={data.excessAmount}
            title={`Excess Amount`}
            className="bg-amber-50 text-amber-400 border-b-amber-400"
            selected={`${selectedBox === "excessAmount"
                ? "border-l-4 border-l-amber-400"
                : ""
              }`}
            onClick={() => handleBoxClick("excessAmount")}
          />
        </BookingGrid>
      </BookingSummary>

      {/* Table Section */}
      <div className="mt-4">
        {selectedTable === "totalTransaction" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <TransactionTable
                  ApiData={error ? [] : data?.data?.collection}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                />
                {(error || data?.data?.collection?.length === 0) &&
                  !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
        {selectedTable === "totalDues" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <DuesTable
                  ApiData={error ? [] : data?.data?.dues}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                  isMarkAsPaidVisible={isMarkAsPaidVisible}
                  setIsMarkAsPaidVisible={setIsMarkAsPaidVisible}
                />
                {(error || data?.data?.dues?.length === 0) && !isLoading && (
                  <NotFoundModel />
                )}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
        {selectedTable === "security" && (
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <SecurityTable
                  ApiData={error ? [] : data?.data?.securityCollection}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                />
                {(error || data?.data?.securityCollection?.length === 0) &&
                  !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}

        {selectedTable === "excessAmount" && (
          // <Table data={data?.excessAmount} />
          <>
            {!error && !isLoading && data && (
              <TableWrapper>
                <SecurityTable
                  ApiData={error ? [] : data?.data?.excessAmount}
                  setSelectedData={setSelectedData}
                  selectedData={selectedData}
                  userType={user.userType}
                />
                {(error || data?.data?.excessAmount) &&
                  !isLoading && <NotFoundModel />}
              </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </>
        )}
      </div>
    </>
  );
};

const BoxComp = ({ value, title, className, selected, onClick }) => (
  <Box
    className={`border-b-4 shadow-lg ${className} ${selected} `}
    onClick={onClick}
  >
    <BoxTitle>
      {title.trim()}
      <hr className={`${className} w-1/3 border-b-2 rounded-full`} />
    </BoxTitle>

    <BoxCount>{compressAmount(value || 0)}</BoxCount>
  </Box>
);

const BookingSummary = tw.div``;
const BookingGrid = tw.div`grid grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 mt-2 md:gap-6 lg:gap-10`;
// const Box = tw.div`w-4/5 min-h-24  rounded-lg shadow-md flex flex-col p-2 justify-start  relative hover:scale-105 transition`;
const Box = tw.div`w-full min-h-24 rounded-lg shadow-md flex flex-col p-4 justify-between relative hover:scale-105 transition`;
const BoxTitle = tw.h3`text-sm sm:text-md lg:text-md font-medium text-left absolute inset-4 uppercase text-zinc-500 font-semibold`;
const BoxCount = tw.p`font-semibold xl:text-[22px] text-[22px] mt-auto`;

const TableWrapper = tw.h1`my-8 border bg-white rounded-md`;

export default Passbook;
